import store from '../store/store';
import { mutatorAction } from 'satcheljs';
import { PremiumLegacyTenantResponse } from '../contracts/premiumLegacyTenantResponse';
import { PurchaseType } from '../contracts/purchaseType';
import isDeprecateLegacyPremiumEnabled from '../utils/isDeprecateLegacyPremiumEnabled';

export default mutatorAction('setPremiumLegacyTenant', function setPremiumLegacyTenant(
    response: PremiumLegacyTenantResponse
) {
    if (response !== null) {
        if (
            isDeprecateLegacyPremiumEnabled() &&
            response.TenantName &&
            response.DomainPurchaseType != PurchaseType.Unknown
        ) {
            store.legacyPremiumTenant = response;
        } else if (!isDeprecateLegacyPremiumEnabled()) {
            store.legacyPremiumTenant = response;
        }
    }
});
